import _ from 'lodash';
import {error} from '.';
import {awsServerBase} from '../config/environment';
import overlayConfig from '../config/overlays';
import {fetchJson} from '../utils/fetch_utils';
import {urlParams} from '../utils/security_utils';
import * as ActionTypes from './actionTypes';

const HEADERS = {
  cache: 'no-cache',
  headers: {
    'Accept': 'application/json'
  }
};

export const populateAwsDataAsync = () => {

  const overlay = _.keyBy(overlayConfig, 'id')['AWS'];

  if (!overlay) {
    return { type: 'DO_NOTHING' };
  }

  const { config } = overlay;
  const base = (overlay.config.base || awsServerBase) + (overlay.config.baseSuffix || '');

  return dispatch => {
    if (!base || !config.listService) {
      dispatch(error('Call to get AWS data for overlay without list service configured.'));
      return;
    }

    fetchJson(_constructListServiceRequestString(base, config.listService, config.securityKey), HEADERS)
    .then(data => _toGeoJson(data))
    .then(data => dispatch(_populateAwsData(data)))
    .catch(err => dispatch(error('Call to get AWS data failed: ' + (err.message || err))));
  };
};

export const populateAwsDataForGraphAsyncPromise = (aws, data_idx) => {
  const overlay = _.keyBy(overlayConfig, 'id')['AWS'];

  if (!overlay) {
    return () => Promise.resolve();
  }

  const { config } = overlay;
  const base = (overlay.config.base || awsServerBase) + (overlay.config.baseSuffix || '');

  return dispatch => {
    if (!base || !config.stationService) {
      dispatch(error('Call to get AWS data for overlay without station service configured.'));
      return Promise.resolve();
    }

    return fetchJson(_constructStationServiceRequestString(base,
        config.stationService,
        config.securityKey,
        aws.stationid),
      HEADERS)
    .then(data => dispatch(_populateAwsGraphData(data, data_idx)))
    .catch(e => {
      const msg = 'Call to get AWS data failed: ' + e.message;
      dispatch(error(msg));
    })
    .then(() => {});
  };
};

const _toGeoJson = (data) => {
  const geoJson = {};
  geoJson.type = 'FeatureCollection';
  geoJson.features = [];

  data.forEach((stationData) => {
    geoJson.features.push(_createAwsFeature(stationData));
  });

  return geoJson;
};

const _createAwsFeature = (data) => {
  const feature = {};
  feature.type = 'Feature';
  feature.properties = { ...data };
  feature.geometry = {
    type: 'Point',
    coordinates: [data.longitude, data.latitude]
  };

  delete feature.properties.longitude;
  delete feature.properties.latitude;

  return feature;
};

const _populateAwsData = (data) => {
  return {
    type: ActionTypes.POPULATE_AWS_DATA,
    data: data
  };
};

const _populateAwsGraphData = (data, data_idx) => {
  return {
    type: ActionTypes.POPULATE_AWS_GRAPH_DATA,
    data, data_idx
  };
};

const _constructListServiceRequestString = (base, service, securityKey) => {
  return `${base}${service}?${urlParams(service, securityKey)}`;
};

const _constructStationServiceRequestString = (base, service, securityKey, station_id) => {
  service = service.replace('{stationId}', station_id);
  return `${base}${service}?${urlParams(service, securityKey)}`;
};



// WEBPACK FOOTER //
// ./src/actions/populate_aws_data.js